<template>
    <div>
      <Heatmap/>
      </div>
  </template>
  <script>
  import Heatmap from "../components/Heatmap.vue";
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "HeatMapPage",
    components: { Heatmap },
    data() {
      return {};
    },
    created() {},
    methods: {},
  };
  </script>
  <style scoped>
  </style>